<style lang="scss" scoped>
	@import "./operation.css";
	.m2 {
		display: none;
	}
	.handmiam:hover{
		.m1 {
			display: none;
		}
		.m2 {
			display: inline-block;
		}
	}
</style>
<style lang='scss'>
#operation{
	
	.pdfview {
		position: fixed;
		width: 100vw;
		height: 100vh;
		left: 0vw;
		top: 0vh;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 99;
		display: none;
	}

	.pdfShow {
		display: block;
	}

	.pdfview .pdfviewIn {
		position: fixed;
		width: 80vw;
		height: 80vh;
		left: calc(50% - 40vw);
		top: 5vh;
	}

	.pdfview .pdfviewIn .pdfTitle {
		/* position: absolute;
		top: 1rem;
		right:3rem; */
		height: 3rem;
		background-color: #fff;
		width: calc(100% + 1px);
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: 2rem;
	}

	.pdfview .pdfviewIn .pdfTitle img {
		width: 1.5rem;
		height: 1.5rem;
		margin-left: 1rem;
		cursor: pointer;
	}
}
	.grayc {
		color: #cfcfcf !important;
	}

	.greenc {
		/* color: #0c8b97 !important; */
		color: #808080 !important;
	}

	#operation .ant-form-item-label {
		/* display: inline-block;
		height: 1px; */
		width: 5rem;
	}
</style>
<template>
	<div id="operation">
		<div class="topHeader" >
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify="space-between">
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="操作人員" class="formItem">
							<!-- <a-select v-model="params.status" placeholder="請選擇操作人員" @change="searchEvent">
								<a-select-option v-for="(item) in admintypeArr" :key="item.key" :value="item.value"
									style='width:100%'>{{item.text}}</a-select-option>
							</a-select> -->
							<Situationall v-model="params.name" :url='$api.getParamList'
								:params='{"type":"adminusers"}' :style='"width:100%"' :placeholder="'請選擇操作人員'">
							</Situationall>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="操作模塊" class="formItem">
							<!-- <a-select v-model="params.module" placeholder="請選擇操作模塊" @change="searchEvent">
								<a-select-option v-for="(item) in admintypeArr" :key="item.key" :value="item.value"
									style='width:100%'>{{item.text}}</a-select-option>
							</a-select> -->
							<Situationall v-model="params.module" :url='$api.getParamList'
								:params='{"type":"adminmodule"}' :style='"width:100%"' :placeholder="'請選擇操作模塊'">
							</Situationall>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="操作狀態" class="formItem">
							<a-select v-model="params.status" placeholder="請選擇操作狀態" @change="searchEvent">
								<a-select-option v-for="(item) in admintypeArr" :key="item.key" :value="item.value"
									style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
							
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="操作日期" class="formItem">
							<a-range-picker :placeholder="['開始日期','結束日期']" format="YYYY/MM/DD"
								v-model="params.timeDate" @change='fanhand'>
							</a-range-picker>
						</a-form-model-item>
					</a-col>
					<a-col style="display: flex;align-items: center;">
						<div class="btn_cla" style="background-color:#3bc7a1;margin-right:1rem;" @click="searchEvent">
							<img src="../../image/icon_sousuo.png" class="btnIcon" />
							<span>搜索</span>
						</div >
						<div class="btn_cla" style="background-color:#ffa647;" @click="clearEvent">
							<img src="../../image/icon_chongzhi.png" class="btnIcon" />
							<span>重置</span>
						</div >
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div class='btn_list' @click="upClick()">
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem'/>
					<span style="color:#3bc7a1;">導出</span>
				</div>
			</div>
			<!-- <div class="tableBtnView"> -->
			<!-- 	<div @click='visible_bold = 1' class='btn_list'>
					<a-icon type="plus-circle" style="color: #a06bf1;font-size: .8rem;margin-right: .3rem;" />
					<span style="color: #a06bf1;">新建用戶</span>
				</div> -->
				<!-- <task :params='params' @child='fandfn' v-if='domaineditadmin'></task> -->
			<!-- </div> -->
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index' :customRow='rowstely'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -2.5rem;"></span>
				<div slot='status' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.status == 2' style="color: #ee5253">暫停</div>
					<div v-if='record.status == 1' style="color: #3bc7a1">使用中</div>
				</div>
				<div slot='email' slot-scope="record" style="white-space: nowrap;">{{record.email}}</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div>
							<img :src="record.visible_bold !== 1?require('../../image/lea/chakan1.png'):require('../../image/lea/chakan.png')" class="imageC" @click='pdfEvent(record)'>
						</div>
						<!-- <div class="popoverView handmiam">
								<img
								:src="require('../../image/mima.png')" alt="" class="imageC m1" @click="handpass(record)">
								<img
								:src="require('../../image/mima2.png')" alt="" class="imageC m2" @click="handpass(record)">
						</div> -->
						<!-- <div class="popoverView" >
							<div>
							<img :src="record.visible_bold1 !== 1?require('../../image/lea/bianji.png'):require('../../image/lea/bianji5.png')" class="imageC" @click='onChange1(record.visible_bold1?1:2,record)' style='width: 1.5rem;'></div>
						</div> -->
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<handItem v-if='visible_bold == 1' @child='handclose' :items='isdate'></handItem>
		<handbiezhu v-if='mima == 1' @child='handclose' :items='isdate'></handbiezhu>
		<div :class="['pdfview',pdfShow?'pdfShow':'']" @click='pdfShowUNEvent()'>
			<div class='pdfviewIn'>
				<div class='pdfTitle'>
					<img src="../../image/icon_dayin.png" alt=""  @click.stop="printEvent()">
					<img @click.stop="downLoad()" src="../../image/icon_xiazai1.png">
				</div>
				<iframe id='iframePdf1' :src='allurl' style='width:100%;height:100%;' frameborder='0'></iframe>
				<iframe id='toPrintIframe' style='display:none' :src='pdfBolUrl' frameborder='0'></iframe>
			</div>
		</div>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
<!-- 		<handhome v-if='visible_home' @child='handclose' :items='isdate'
		:itemobj='{}' :applyid='{}'  ></handhome> -->
	</div>
</template>
<script>
	import exportData from "./components/exportData";
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import handItem from './components/handItem'
	import handbiezhu from './components/handbiezhu'
	// import handhome from './components/handhome'
	import handhome from './comhome/handhome'
	import pushbtn from './components/pushbtn'
	import { saveFileToLink,saveFileToBlob  } from 'web-downloadfile';
	import task from './components/task.vue'

	export default {
		components: {
			handItem,
			task,
			pushbtn,
			handbiezhu,
			exportData,
			handhome
		},
		data() {
			return {
				upFlag:false,
				ishandout:false,
				pdfShow:false,
				allurl:'',
				pdfBolUrl:'',
				pdfUrl : '',
				blob:'',
				text: `A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found as a welcome guest in many households across the world.`,
				visible_home: false,
				isdate: '',
				visible_bold: '',
				mima:'',
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限    
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				icon_pdf,
				icon_pdf1,
				//域名新增權限 domaininsertadmin
				//域名編輯權限 domaineditadmin
				domaininsertadmin: this.$store.state.rolesdata.indexOf('domaininsertadmin') >= 0,
				domaineditadmin: this.$store.state.rolesdata.indexOf('domaineditadmin') >= 0,
				admintypeArr: [{
					text: '全部',
					value: ''
				},{
					text: '使用中',
					value: '1'
				}, {
					text: '暫停',
					value: '2'
				}],
				tzPageNum: '',
				columns: [{
					// title: '',
					// 	dataIndex: '',
					// 	align: 'center',
					// 	width: '5%',
					// 	slots: {
					// 		title: 'alltext'
					// 	},
					// },
					// {
						title: '操作人員',
						dataIndex: 'name',
						align: 'center',
						width: '20%'
					},
					{
						title: '操作模塊',
						dataIndex: 'module',
						align: 'center',
						width: '13%'
					},
					{
						title: '操作權限',
						dataIndex: 'permissions',
						align: 'center',
						width: '14%',
					},
					{
						title: '操作信息',
						dataIndex: 'ip',
						align: 'center',
						width: '15%',
					},
					{
						title: '操作時間',
						dataIndex: 'handletime',
						align: 'center',
						width: '13%',
					}, {
						title: '操作狀態',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots: {
							customRender: 'status'
						}
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					position: '',
					module: '',
					permissions: '',
					ip: '',
					status: '',
					createtime_begin:'',
					createtime_end:'',
					timeDate:[]
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
		},
		methods: {
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent1(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			// 表格导出下载
			queryData(pxfs){
				let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.operationRecords;
				url += '?token=' + this.$store.state.token
				url += '&name=' +this.params.name
				url += '&sort=' + sort
				url += '&name=' +this.params.name
				url += '&module=' +this.params.module
				url += '&status=' +this.params.status
				url += '&beginTime=' +this.params.createtime_begin
				url += '&endTime=' + this.params.createtime_end
				console.log(url);
				window.location.href = url;
			},
			upClick(){
				this.upFlag = true
			},
			handleCancel(ev){
                this.ishandout = false
			},
			downLoad(){
                let _this = this;
				const date = new Date();
				const year = date.getFullYear();
				let month = date.getMonth() + 1;
				if (month < 10) {
					month = `0${month}`;
				}
				let day = date.getDate();
				if (day < 10) {
					day = `0${day}`;
				}
				var currentDate = `${year}${month}${day}`;

				saveFileToBlob(_this.blob,currentDate + ' 操作記錄','pdf');
            },
			pdfEvent(val){
				let str = this.$api.pdfs;
				let url = this.$api.operationPersonLogPDF;
				url += '?token=' + this.$store.state.token
				url += '&beginTime=' +this.params.createtime_begin
				url += '&endTime=' + this.params.createtime_end
				url += '&adminid=' + val.adminid
				this.allurl = str + url;
				let _this = this; 
				_this.pdfUrl = url;
				https.fetchGetPdf(_this.pdfUrl).then((data)=>{
					let blob = new Blob([data],{
						type:'application/pdf'
					})
					_this.blob = blob;
					let b=window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err=>{
					console.log(err)
				})
				setTimeout(()=>{
					this.pdfShow = true
				},500)
			},
			pdfEvent1(pxfs){
				let sort =  pxfs == undefined ? '' : pxfs
				let str = this.$api.pdfs;
				let url = this.$api.exportOperationLogPDF;
				url += '?token=' + this.$store.state.token
				url += '&name=' +this.params.name
				url += '&sort=' + sort
				url += '&name=' +this.params.name
				url += '&module=' +this.params.module
				url += '&status=' +this.params.status
				url += '&beginTime=' +this.params.createtime_begin
				url += '&endTime=' + this.params.createtime_end
				this.allurl = str + url;
				let _this = this; 
				_this.pdfUrl = url;
				https.fetchGetPdf(_this.pdfUrl).then((data)=>{
					let blob = new Blob([data],{
						type:'application/pdf'
					})
					_this.blob = blob;
					let b=window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err=>{
					console.log(err)
				})
				setTimeout(()=>{
					this.pdfShow = true
				},500)
			},
			printEvent(){
			    let _this = this;
			    const printIframe = document.getElementById("toPrintIframe");
			    let frameWindow = printIframe.contentWindow;
			    frameWindow.print();
			    setTimeout(()=>{
			        window.URL.revokeObjectURL(_this.blob);
			    },500)
			},
			pdfShowUNEvent(){
				this.pdfShow = false
				// this.messLoad()
			},
			fanhand(val) {
				this.params.createtime_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]._d) : '',
				//認購截止日期
				this.params.createtime_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]._d) : ''
			},
			onChange1(checked,v) {
				// if(checked == 'drop'){
				// 	return
				// }
				// this.visible_home = true;
				this.mima = true
				this.isdate = v
				console.log(v)
			},
			handquanxain(val) {
				val.visible_bold = false
				// this.visible_home = true;
				this.visible_bold = true
				this.isdate = val
				console.log(val)
			},
			handpass(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.editAdmin,
					data: {
						"userid": val.userid,
						"resetpassword": 1,
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.messLoad();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			rowstely(record, index) {
				if (record.status == "已過期"||record.status == 2) {
					return {
						style: {
							'color': '#999',
							opacity: '.5'
						},
					}
				}
			},
			deletefn(ev) {
				// this.$ajax({
				// 	method: 'post',
				// 	url: this.$api.deletOther,
				// 	headers: {
				// 		token: this.$store.state.token
				// 	},
				// 	data: {
				// 		"token": this.$store.state.token,
				// 		"systemserviceid": ev.systemserviceid,
				// 		"flag": "systemservice"
				// 	}
				// }).then(res => {
				// 	if (res.data.qmiscode === 1000) {
				// 		this.$message.success('操作成功')
				// 		this.messLoad();
				// 	} else {
				// 		this.$message.warning(res.data.qmismsg)
				// 	}
				// }).catch(err => {
				// 	console.log(err);
				// });
			},
			handediot(val, a) {
				this.isdate = val.systemserviceid;
				// console.log(val)
				this.visible_bold = a;
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			fandfn(val) {
				if (val == 'back') {
					this.params.missionflag = 0
					this.params.status = ''
				} else {
					this.params.missionflag = 1
					this.params.status = val == '即將到期' ? '3' : ''
				}
				this.messLoad()
			},
			handopen() {
				window.location.href = this.$api.getExcel + '?token=' + this.$store.state.token
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand1(val) {

			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {

					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.isdate = ''
				this.visible_bold = '';
				this.mima = ''
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['visible_bold'] = ''
						ev['mima'] = ''
					}
				})
				this.visible_home = false;
				if (val) {
					this.messLoad();
				}
			},
			messLoad() {
				
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getAllAdminHandleLogs,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.handlelogs
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = ''
								ev['mima']=''
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.name || this.params.module || this.params.status || this.params.createtime_begin) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},
			clearEvent() {
				window.location.reload();
				// this.params = {}
				// this.params = {
				// 	missionnum: 0,
				// 	pageNum: 1, //當前頁數
				// 	total: 1,
				// 	perPage: 10, //每頁條目數
				// 	position: '',
				// 	module: '',
				// 	permissions: '',
				// 	ip: '',
				// 	name: '',
				// 	status: '',
				// }
				// this.messLoad();
			},// biaoqing
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>


